import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}
document.addEventListener('DOMContentLoaded', function() {
  function fixTitleWidth() {
    document.querySelectorAll('.group-block').forEach(function(el) {
      el.style.setProperty('--size-style-width', '100%', 'important');
      el.style.width = '100%';
    });
  }
  fixTitleWidth();
  setTimeout(fixTitleWidth, 300);
  setTimeout(fixTitleWidth, 1000);
});

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
